import { render, staticRenderFns } from "./FileDropper.vue?vue&type=template&id=47888d12&"
import script from "./FileDropper.vue?vue&type=script&lang=js&"
export * from "./FileDropper.vue?vue&type=script&lang=js&"
import style0 from "./FileDropper.vue?vue&type=style&index=0&id=47888d12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports